import {
  AppBar,
  Box,
  styled,
  Theme,
  Toolbar,
  useMediaQuery,
} from "@mui/material";
import NotificationsPopover from "./popovers/NotificationsPopover";
import ProfilePopover from "./popovers/ProfilePopover";
import { useNavigate } from "react-router-dom";
// root component interface
type DashboardNavBarProps = {
  userImages?: string;
};

// custom styled components
const DashboardNavbarRoot = styled(AppBar)(() => ({
  zIndex: 11,
  paddingTop: "0.6rem",
  paddingBottom: "0.4rem",
  backdropFilter: "blur(6px)",
  paddingLeft: 4,
  paddingRight: 4,
  background: "#FFFFFF",
  boxShadow: "0px 4px 5px -2px rgba(0,0,0,0.1)",
}));

const StyledToolBar = styled(Toolbar)(() => ({
  "@media (min-width: 0px)": {
    paddingLeft: 70,
    paddingRight: 70,
    minHeight: "auto",
  },
}));

// root component
function DashboardNavbar({ userImages }: DashboardNavBarProps) {
  const upSm = useMediaQuery((theme: Theme) => theme.breakpoints.up("sm"));
  const downSm = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
  let navigate = useNavigate();
  if (downSm) {
    return (
      <DashboardNavbarRoot position="sticky">
        <StyledToolBar
          sx={{
            justifyContent: "space-between",
            display: "flex",
            paddingLeft: {
              xs: 2,
            },
            paddingRight: {
              xs: 2,
            },
          }}
        >
          <Box
            component="img"
            textAlign="center"
            onClick={() => {
              navigate("/dashboard");
            }}
            sx={{
              height: 40,
              width: 80,
              cursor: "pointer",
            }}
            src={process.env.REACT_APP_LOGO}
          />
          <Box sx={{}}>
            <NotificationsPopover />
            <ProfilePopover userImages={userImages} />
          </Box>
        </StyledToolBar>
      </DashboardNavbarRoot>
    );
  }

  return (
    <DashboardNavbarRoot position="sticky">
      <StyledToolBar>
        <Box
          sx={{
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            sx={{
              height: {
                xs: "10%",
                sm: "10%",
                md: "10%",
              },
              width: {
                xs: "17%",
                sm: "17%",
                md: "100%",
              },
              ml: 1,
              cursor: "pointer",
            }}
            onClick={() => {
              navigate("/dashboard");
            }}
            src={process.env.REACT_APP_LOGO}
            alt="saas-dasboard-footer"
          />
        </Box>

        <Box flexGrow={1} ml={1} />

        {upSm && (
          <>
            <NotificationsPopover />
          </>
        )}
        <ProfilePopover />
      </StyledToolBar>
    </DashboardNavbarRoot>
  );
}

export default DashboardNavbar;
